module.exports = __webpack_public_path__ + "assets/f3736a60327e875ff05e4dd46036be42.png";